export default __webpack_public_path__ + "img/star.bdfd36a.svg";